import * as React from 'react';
import { connect } from 'react-redux';
import { FromToControl } from '../../../../common/components/from_to_control';
import { IAppState, Dispatch } from '../../../../common/state';
import { IJsonQueryRange } from '../../../../json_query';
import { changeMaxArea, changeMinArea } from '../../../state/advanced/area';
import { InlineParam, Row } from '../markup';

const style = require('../index.css');

const AREA_MAX_LENGTH = 5;

export interface ISiteAreaProps {
  siteArea: { gte?: number; lte?: number };
  onMinAreaChanged(value: number | undefined): void;
  onMaxAreaChanged(value: number | undefined): void;
  shortView?: boolean;
}

export const area: React.StatelessComponent<ISiteAreaProps> = props => {
  const fromToControl = (
    <FromToControl
      rangeGroupStyle={style['fromToControl']}
      from={{
        value: props.siteArea.gte,
        placeholder: 'от',
        maxLength: AREA_MAX_LENGTH,
        onValueChange: value => props.onMinAreaChanged(value),
      }}
      to={{
        value: props.siteArea.lte,
        placeholder: 'до',
        maxLength: AREA_MAX_LENGTH,
        onValueChange: value => props.onMaxAreaChanged(value),
      }}
    />
  );

  return props.shortView ? (
    fromToControl
  ) : (
    <Row title="Площадь участка">
      <InlineParam>{fromToControl}</InlineParam>
      {'сот.'}
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect<
  { siteArea: IJsonQueryRange | {} },
  {
    onMinAreaChanged(value: number | undefined): void;
    onMaxAreaChanged(value: number | undefined): void;
  },
  { shortView?: boolean }
>(
  (state: IAppState) => ({
    siteArea: (state.filters.jsonQuery.site && state.filters.jsonQuery.site.value) || {},
  }),
  (dispatch: Dispatch) => ({
    onMinAreaChanged: (value: number | undefined) => {
      dispatch(changeMinArea('site_area', value));
    },
    onMaxAreaChanged: (value: number | undefined) => {
      dispatch(changeMaxArea('site_area', value));
    },
  }),
  // tslint:disable-next-line: no-any
)(area as any);
